export default {
	state: {
		component: "",
	},
	mutations: {
		setPenalty(state, payload) {
			state.component = payload.componentName;
		},
		resetPenalty(state) {
			state.component = "";
		},
	},
};



// WEBPACK FOOTER //
// ./src/store/penalty.js